import { FC } from 'react'

type BackdropProps = {
  close: () => void
}

const Backdrop: FC<BackdropProps> = ({ close }) => {
  return (
    <div
      className="backdrop"
      onClick={close}
      onTouchStart={close}
      aria-hidden="true"
    />
  )
}

export default Backdrop
